import { useState, useEffect } from 'react';
import fantasyService from '../services/fantasyService';
import { useAuth } from '../context/AuthContext';

export const useFantasyPlayers = (season = 2024) => {
  const [players, setPlayers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPlayers = async () => {
      try {
        setLoading(true);
        const data = await fantasyService.getAllPlayers(season);
        setPlayers(Array.isArray(data) ? data : []);
        setError(null);
      } catch (err) {
        setError(err.message || 'Failed to fetch players');
        setPlayers([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPlayers();
  }, [season]);

  return { players, loading, error };
};

export const useGameweekStats = (gameweekNumber, season = 2024) => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      if (!gameweekNumber) return;
      try {
        setLoading(true);
        const data = await fantasyService.getGameweekStats(gameweekNumber, season);
        setStats(data);
        setError(null);
      } catch (err) {
        setError(err.message || 'Failed to fetch gameweek stats');
        setStats(null);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, [gameweekNumber, season]);

  return { stats, loading, error };
};

export const useGameweekLeaderboard = (gameweekNumber, season = 2024) => {
  const [leaderboard, setLeaderboard] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLeaderboard = async () => {
      if (!gameweekNumber) return;
      try {
        setLoading(true);
        const data = await fantasyService.getGameweekLeaderboard(gameweekNumber, season);
        setLeaderboard(data);
        setError(null);
      } catch (err) {
        setError(err.message || 'Failed to fetch leaderboard');
        setLeaderboard(null);
      } finally {
        setLoading(false);
      }
    };

    fetchLeaderboard();
  }, [gameweekNumber, season]);

  return { leaderboard, loading, error };
};

export const useFixtures = (season = 2024) => {
  const [fixtures, setFixtures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFixtures = async () => {
      try {
        setLoading(true);
        const data = await fantasyService.getAllFixtures(season);
        setFixtures(Array.isArray(data) ? data : []);
        setError(null);
      } catch (err) {
        setError(err.message || 'Failed to fetch fixtures');
        setFixtures([]);
      } finally {
        setLoading(false);
      }
    };

    fetchFixtures();
  }, [season]);

  return { fixtures, loading, error };
};
